const palettes = {
  nordic: [
    '#2C3845',
    '#872B32',
    '#DCAA34',
    '#1C361F',
    '#A5B06F',
    '#C6B58E',
    '#855937',
  ],
  newNordic: [
    '#93868A',
    '#C59F86',
    '#A06C60',
    '#6A6C62',
    '#241E20',
    '#D8D0BF',
    '#C9C1B0',
    '#C1B3A4',
    '#EDE9E1',
    '#CAC6BE',
    '#BFBAB2',
    '#B1A79D',
    '#D8DAD0',
    '#C8CEC3',
    '#A3A598',
    '#8D8F85',
    '#E2DBC6',
    '#DFCDB2',
    '#CCBC9C',
    '#C6B091',
    '#E0D1C2',
    '#D6BDA8',
    '#C5A891',
    '#B1947D',
    '#DCCEBF',
    '#CCB8AB',
    '#C1A899',
    '#98796C',
  ],
}

const toColor = (string, colors = palettes.nordic) => {
  var hash = 0

  if (!string || string.length === 0) {
    return colors[hash]
  }

  for (var i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
    hash = hash & hash
  }

  hash = ((hash % colors.length) + colors.length) % colors.length

  return colors[hash]
}

export default function useColor(string) {
  return toColor(string)
}
